import React from 'react';
import UserExistsView from '../Views/TO/Register/UserExistsView';

class UserExists extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
        };
        this.startOver = this.startOver.bind(this);
    }

    startOver() {
        this.props.displayForm("CREATE")
    }

    render() {
        return (
            <UserExistsView
                email={this.props.email}
                startOver={this.startOver}
                style={this.props.style}
            />
        );
    }
}

export default UserExists;